import script from "./OnlineServiceLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./OnlineServiceLinks.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__